import React from "react";
import moment from "moment";

export const handoverSectionTableHeaderData = (isDarkMode = false) => [
  {
    id: 1,
    formFieldId: 1,
    minWidth: 135,
    headerName: "Installment %",
    field: "installment",
    sortable: true,
    filterable: true,
    fieldType: "text",
    displayPath: "installment",
    isDefaultFilterColumn: true,
    fieldKey: "installment",
    formFieldTitle: "Installment",
    disableColumnMenu: true,
    searchKey: "installment",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#475467" : "#94969C",
          }}
        >
          {item?.row?.amountPercentage
            ? `${parseFloat(item.row.amountPercentage)}%`
            : "N/A"}
        </label>
      );
    },
  },
  {
    id: 2,
    formFieldId: 2,
    minWidth: 130,
    headerName: "Trigger Type",
    field: "triggerType",
    sortable: true,
    filterable: true,
    fieldType: "text",
    displayPath: "triggerType",
    isDefaultFilterColumn: true,
    fieldKey: "triggerType",
    formFieldTitle: "Trigger Type",
    disableColumnMenu: true,
    searchKey: "triggerType",
    renderCell: (item) => {
      let label = "N/A";
      const freq = (item?.row?.frequencyName || "").toLowerCase();
      if (item?.row?.numberOfInstallment) {
        label = "by-month";
      } else if (freq === "date") {
        label = "by-fixed-date";
      } else if (
        freq === "month" ||
        freq === "year" ||
        freq === "construction progress" ||
        freq === "completion"
      ) {
        label = "by-duration";
      } else {
        label = item?.row?.frequencyName || "N/A";
      }
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {label}
        </label>
      );
    },
  },
  {
    id: 3,
    formFieldId: 3,
    minWidth: 135,
    headerName: "Trigger Value",
    field: "triggerValue",
    sortable: true,
    filterable: true,
    fieldType: "text",
    displayPath: "triggerValue",
    isDefaultFilterColumn: true,
    fieldKey: "triggerValue",
    formFieldTitle: "Trigger Value",
    disableColumnMenu: true,
    searchKey: "triggerValue",
    renderCell: (item) => {
      const { frequencyName, frequencyValue } = item?.row || {};
      const freq = (frequencyName || "").toLowerCase();
      let value = "-";
      if (freq === "month" || freq === "year") {
        value = frequencyValue
          ? `${frequencyValue} ${freq}${
              parseFloat(frequencyValue) === 1 ? "" : "s"
            }`
          : "-";
      } else if (freq === "date") {
        value = frequencyValue
          ? moment(frequencyValue).isValid()
            ? moment(frequencyValue).format("DD-MMM-YYYY")
            : frequencyValue
          : "-";
      } else if (freq === "construction progress" || freq === "completion") {
        value = frequencyValue ? `${frequencyValue}% completion` : "-";
      } else {
        value = frequencyValue || "-";
      }
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#475467" : "#94969C",
          }}
        >
          {value}
        </label>
      );
    },
  },
  {
    id: 4,
    formFieldId: 4,
    minWidth: 205,
    headerName: "Number of Installments",
    field: "numberOfInstallments",
    sortable: true,
    filterable: true,
    fieldType: "text",
    displayPath: "numberOfInstallments",
    isDefaultFilterColumn: true,
    fieldKey: "numberOfInstallments",
    formFieldTitle: "Number of Installments",
    disableColumnMenu: true,
    searchKey: "numberOfInstallments",
    renderCell: (item) => {
      return (
        <label
          style={{
            fontWeight: 400,
            color: !isDarkMode ? "#101828" : "#F5F5F6",
          }}
        >
          {item?.row?.numberOfInstallment || "-"}
        </label>
      );
    },
  },
];
